import React, { FC, Fragment } from 'react';
import { Box, Grid, Theme, useMediaQuery } from '@mui/material';
import { Order, OrderStatus } from 'models/order';
import { currentUserVar } from 'apollo/reactive-variables/user';
import { permissions } from 'utils/permission';
import { CONSTANTS } from 'config/constants';
import { customerSettings } from 'utils/customerSettings';
import { currentOrgVar } from 'apollo/reactive-variables/organization';
import { OrderItemEvent } from 'models/order-item-events';
import ExternalLabUsersIconButton from 'components/orders/shared/order-item-icon-area/external-lab-users-icon-button.component';
import IconAreaTruckButton from 'components/orders/shared/order-item-icon-area/icon-area-truck-button.component';
import DeleteDraftIconButton from 'components/orders/shared/order-item-icon-area/delete-draft-icon-button.component';
import IconAreaNotificationsIcon from 'components/orders/shared/order-item-icon-area/icon-area-notificatios-icon.component';
import LinkedDentistsIconButton from 'components/orders/shared/order-item-icon-area/linked-dentists-icon-button.component';
import InternalNotesIcon from './internal-notes-icon.component';

type OrderItemIconAreaProps = {
    order: Order;
    deleteDraftOrder?: () => void;
    onOrderItemEvent?: (event: OrderItemEvent) => void;
};
const OrderItemIconArea: FC<OrderItemIconAreaProps> = ({
    order,
    deleteDraftOrder,
    onOrderItemEvent,
}: OrderItemIconAreaProps) => {
    const currentUser = currentUserVar();
    const currentOrganization = currentOrgVar();

    const isComputerScreen = useMediaQuery((theme: Theme) => theme.breakpoints.up('lg'));
    const shouldShowDeleteDraftButton =
        order.status === OrderStatus.DRAFT || order.status === OrderStatus.COMPLETED_DRAFT;
    const isExternalLabUsersEnabled = customerSettings.getCustomerSetting(
        currentOrganization.customerSettings,
        CONSTANTS.SETTINGS_NAMES.EXTERNAL_LAB_USERS,
    );

    return (
        <Fragment>
            {isComputerScreen ? (
                <Grid container rowSpacing={1} columnSpacing={0.5} alignItems="center">
                    {!shouldShowDeleteDraftButton ? (
                        <Fragment>
                            <Grid item md={6} xl={3} flexGrow={1}>
                                <Box sx={{ textAlign: 'center', marginTop: '-5px' }}>
                                    {isExternalLabUsersEnabled && permissions.isLabTechnician(currentUser.type) ? (
                                        <ExternalLabUsersIconButton order={order} onOrderItemEvent={onOrderItemEvent} />
                                    ) : undefined}
                                    {permissions.isDentist(currentUser.type) ? (
                                        <LinkedDentistsIconButton order={order} onOrderItemEvent={onOrderItemEvent} />
                                    ) : undefined}
                                </Box>
                            </Grid>
                            <Grid item md={6} xl={3} flexGrow={1}>
                                <Box sx={{ textAlign: 'center' }}>
                                    <InternalNotesIcon isInternalOrderData={order?.isInternalOrderData || false} />
                                </Box>
                            </Grid>
                            <Grid item md={6} xl={3} flexGrow={1}>
                                <Box sx={{ textAlign: 'center' }}>
                                    <IconAreaTruckButton order={order} onOrderItemEvent={onOrderItemEvent} />
                                </Box>
                            </Grid>
                        </Fragment>
                    ) : undefined}

                    {shouldShowDeleteDraftButton ? (
                        <Grid item md={6} xl={3} flexGrow={1}>
                            <Box sx={{ textAlign: 'center' }}>
                                {/* TODO: Use OrderItemEvent for delete draft */}
                                <DeleteDraftIconButton onDeleteDraftOrder={deleteDraftOrder} />
                            </Box>
                        </Grid>
                    ) : undefined}

                    <Grid item md={6} xl={3} flexGrow={1}>
                        <Box sx={{ textAlign: 'center' }}>
                            <IconAreaNotificationsIcon order={order} />
                        </Box>
                    </Grid>
                </Grid>
            ) : undefined}
        </Fragment>
    );
};

export default OrderItemIconArea;
